import React, { useCallback, useEffect, useState } from 'react';
import { Users, CheckCircle, Ruler, Truck, ThumbsUp, Calendar, MessageSquare, Lightbulb, Paintbrush, Wrench, ArrowRight, ChevronDown, ChevronUp, ChevronLeft, ChevronRight, Play, Pause } from 'lucide-react';
export const AboutUs = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [expandedFaq, setExpandedFaq] = useState(null);
  // Project slider implementation
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const projectImages = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kiDtckW7d51UoZiKrqj89j/Afbeelding_van_WhatsApp_op_2025-04-23_om_16.02.16_5dcc6d81.jpg',
    caption: 'Project voltooid: Moderne veranda met polycarbonaat dak'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dvwXXe6p817fxpz161qRRp/Afbeelding_van_WhatsApp_op_2025-04-23_om_16.02.16_cb157875.jpg',
    caption: 'Installatie in uitvoering: Framewerk en constructie'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/67a8pJg9TPo8M3eTLZxSWV/Afbeelding_van_WhatsApp_op_2025-04-23_om_16.02.17_55a02d27.jpg',
    caption: 'Vakmanschap in actie: Precisie bij het opmeten en installeren'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4bw8n27CX3HEE1pjHeafEb/Afbeelding_van_WhatsApp_op_2025-04-23_om_16.02.16_61d35939.jpg',
    caption: 'Voorbereiding: Constructie klaar voor montage'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7nk9VQSmML7hwtXboprLaz/IMG-20250423-WA0012.jpg',
    caption: 'Eindresultaat: Stijlvolle en duurzame overkapping'
  }];
  const nextSlide = useCallback(() => {
    setCurrentSlide(prev => (prev + 1) % projectImages.length);
  }, [projectImages.length]);
  const prevSlide = useCallback(() => {
    setCurrentSlide(prev => (prev - 1 + projectImages.length) % projectImages.length);
  }, [projectImages.length]);
  // Auto-advance slides when not paused
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        nextSlide();
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [isPaused, nextSlide]);
  const togglePause = () => {
    setIsPaused(!isPaused);
  };
  const toggleFaq = index => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };
  const workSteps = [{
    id: 1,
    title: 'Kennismaking & Advies',
    description: 'We beginnen met een vrijblijvend gesprek om uw wensen en mogelijkheden te bespreken. Onze adviseur denkt met u mee en geeft eerlijk advies.',
    icon: <MessageSquare className="h-10 w-10" data-id="element-59" />,
    color: 'bg-[#CDA735]/10 text-[#CDA735]'
  }, {
    id: 2,
    title: 'Ontwerp & Offerte',
    description: 'Op basis van uw wensen maken we een ontwerp op maat en stellen een transparante offerte op zonder verborgen kosten.',
    icon: <Lightbulb className="h-10 w-10" data-id="element-60" />,
    color: 'bg-blue-50/10 text-blue-400'
  }, {
    id: 3,
    title: 'Planning & Voorbereiding',
    description: 'Na akkoord plannen we de uitvoering in en zorgen we voor alle benodigde materialen en vergunningen.',
    icon: <Calendar className="h-10 w-10" data-id="element-61" />,
    color: 'bg-green-50/10 text-green-400'
  }, {
    id: 4,
    title: 'Productie & Maatwerk',
    description: 'In onze eigen productiefaciliteit worden alle onderdelen op maat gemaakt, met oog voor kwaliteit en detail.',
    icon: <Ruler className="h-10 w-10" data-id="element-62" />,
    color: 'bg-purple-50/10 text-purple-400'
  }, {
    id: 5,
    title: 'Installatie & Montage',
    description: 'Ons ervaren team zorgt voor een vakkundige installatie, met minimale overlast en een strakke afwerking.',
    icon: <Wrench className="h-10 w-10" data-id="element-63" />,
    color: 'bg-orange-50/10 text-orange-400'
  }, {
    id: 6,
    title: 'Oplevering & Nazorg',
    description: 'Na oplevering nemen we alles met u door en blijven we beschikbaar voor service en onderhoud.',
    icon: <CheckCircle className="h-10 w-10" data-id="element-64" />,
    color: 'bg-teal-50/10 text-teal-400'
  }];
  const faqs = [{
    question: 'Wat is het werkgebied van Veranova?',
    answer: 'Wij zijn actief in heel Nederland. Dankzij onze efficiënte werkmethode en betrokken team kunnen we snel schakelen zonder concessies te doen aan kwaliteit, ongeacht de locatie.'
  }, {
    question: 'Hoe lang duurt een gemiddeld project?',
    answer: 'De doorlooptijd varieert per project. Een standaard veranda kan binnen 2-3 weken gerealiseerd worden, terwijl complexere projecten zoals een complete tuinkamer 4-6 weken kunnen duren. Tijdens het adviesgesprek kunnen we een exacte planning voor uw specifieke situatie maken.'
  }, {
    question: 'Verzorgt Veranova ook de benodigde vergunningen?',
    answer: 'Ja, wij kunnen u ondersteunen bij het aanvragen van de benodigde vergunningen. We informeren u over de lokale regelgeving en kunnen, indien gewenst, het vergunningstraject voor u verzorgen.'
  }, {
    question: 'Wat voor garantie biedt Veranova op de producten en installatie?',
    answer: 'Wij bieden standaard 10 jaar garantie op constructie en materialen, en 5 jaar op de installatie. Voor specifieke onderdelen zoals elektrische componenten gelden de fabrieksgaranties. Alle garantievoorwaarden worden duidelijk vermeld in onze offerte.'
  }];
  return <div className="min-h-screen bg-white w-full" data-id="element-65">
      {/* Hero section */}
      <section className="relative -mt-[100px] pt-52 pb-32 bg-gray-900 overflow-hidden" data-id="element-66">
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{
        backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/31qoFLD89xVNfcg4Xki5Xk/491436229_17850212535441316_3063343797506131228_n.jpg')"
      }} data-id="element-67"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/90 via-gray-900/70 to-gray-900/90" data-id="element-68"></div>
        <div className="container mx-auto px-6 relative z-10" data-id="element-69">
          <div className="max-w-3xl" data-id="element-70">
            <div className="inline-flex items-center gap-3 mb-6" data-id="element-71">
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-72"></div>
              <span className="text-sm font-medium text-[#CDA735] uppercase tracking-wider" data-id="element-73">
                Over ons
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-74">
              Vakmanschap met <span className="text-[#CDA735]" data-id="element-75">passie</span>{' '}
              voor kwaliteit
            </h1>
            <p className="text-xl text-white/80 mb-8 leading-relaxed" data-id="element-76">
              Bij Veranova geloven we in écht vakwerk. Wij realiseren
              hoogwaardige veranda's, tuinkamers en meer die perfect aansluiten
              bij uw woning en wensen.
            </p>
          </div>
        </div>
      </section>
      {/* About section */}
      <section className="py-20 bg-white" data-id="element-77">
        <div className="container mx-auto px-6" data-id="element-78">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-79">
            <div data-id="element-80">
              <div className="inline-flex items-center gap-3 mb-4" data-id="element-81">
                <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-82"></div>
                <span className="text-sm font-medium text-[#B89429] uppercase tracking-wider" data-id="element-83">
                  Veranova Klussen
                </span>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-84">
                Meer dan 500 tevreden klanten gingen u voor
              </h2>
              <div className="space-y-6 text-gray-700" data-id="element-85">
                <p className="text-lg leading-relaxed" data-id="element-86">
                  Bij Veranova Klussen realiseren we hoogwaardige veranda's,
                  tuinkamers, carports en schuifwanden die perfect aansluiten
                  bij uw woning, tuin en wensen. Geen snelle
                  standaardoplossingen, maar duurzame constructies op maat – tot
                  in de kleinste details.
                </p>
                <p className="text-lg leading-relaxed" data-id="element-87">
                  Ons team bestaat uit ervaren specialisten die dagelijks werken
                  aan projecten met één doel: u voorzien van een stijlvolle,
                  solide en onderhoudsarme oplossing waar u jarenlang van kunt
                  genieten.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-6 mt-8" data-id="element-88">
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-89">
                  <div className="text-[#CDA735] mb-3" data-id="element-90">
                    <CheckCircle className="h-8 w-8" data-id="element-91" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-92">
                    Vakmanschap
                  </h3>
                  <p className="text-gray-600" data-id="element-93">
                    Precisie en oog voor detail in elk project dat we uitvoeren
                  </p>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-94">
                  <div className="text-[#CDA735] mb-3" data-id="element-95">
                    <div className="h-8 w-8" data-id="element-96" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-97">
                    Maatwerk
                  </h3>
                  <p className="text-gray-600" data-id="element-98">
                    Oplossingen die perfect passen bij uw specifieke situatie
                  </p>
                </div>
              </div>
            </div>
            <div className="relative" data-id="element-99">
              <div className="rounded-xl overflow-hidden shadow-2xl" data-id="element-100">
                {/* Project Image Slider */}
                <div className="relative h-[500px] w-full" data-id="element-101">
                  {/* Images */}
                  {projectImages.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} data-id="element-102">
                      <img src={image.url} alt={`Veranova project: ${image.caption}`} className="w-full h-full object-cover" data-id="element-103" />
                      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-6" data-id="element-104">
                        <p className="text-white text-sm md:text-base font-medium" data-id="element-105">
                          {image.caption}
                        </p>
                      </div>
                    </div>)}
                  {/* Navigation controls */}
                  <div className="absolute inset-0 flex items-center justify-between p-4 z-20" data-id="element-106">
                    <button onClick={prevSlide} className="bg-black/30 backdrop-blur-sm p-2 rounded-full text-white hover:bg-[#CDA735]/80 transition-colors" aria-label="Vorige afbeelding" data-id="element-107">
                      <ChevronLeft className="h-5 w-5" data-id="element-108" />
                    </button>
                    <button onClick={nextSlide} className="bg-black/30 backdrop-blur-sm p-2 rounded-full text-white hover:bg-[#CDA735]/80 transition-colors" aria-label="Volgende afbeelding" data-id="element-109">
                      <ChevronRight className="h-5 w-5" data-id="element-110" />
                    </button>
                  </div>
                  {/* Play/Pause control */}
                  <button onClick={togglePause} className="absolute bottom-4 right-4 z-20 bg-black/30 backdrop-blur-sm p-2 rounded-full text-white hover:bg-[#CDA735]/80 transition-colors" aria-label={isPaused ? 'Afspelen' : 'Pauzeren'} data-id="element-111">
                    {isPaused ? <Play className="h-4 w-4" data-id="element-112" /> : <Pause className="h-4 w-4" data-id="element-113" />}
                  </button>
                  {/* Indicator dots */}
                  <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20 flex space-x-2" data-id="element-114">
                    {projectImages.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentSlide ? 'bg-[#CDA735] w-4' : 'bg-white/60 hover:bg-white'}`} aria-label={`Ga naar afbeelding ${index + 1}`} data-id="element-115" />)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Values section */}
      <section className="py-20 bg-gray-50" data-id="element-116">
        <div className="container mx-auto px-6" data-id="element-117">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-118">
            <div className="inline-flex items-center gap-3 mb-4 justify-center" data-id="element-119">
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-120"></div>
              <span className="text-sm font-medium text-[#B89429] uppercase tracking-wider" data-id="element-121">
                Onze waarden
              </span>
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-122"></div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-123">
              Waar Veranova voor staat
            </h2>
            <p className="text-lg text-gray-600" data-id="element-124">
              Een veranda of tuinkamer is meer dan een aanbouw – het is een
              verlengstuk van uw leefruimte. Daarom luisteren wij goed naar uw
              wensen, denken we met u mee en adviseren we u eerlijk.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-125">
            {[{
            icon: <Paintbrush className="h-10 w-10" data-id="element-126" />,
            title: 'Vakmanschap',
            description: 'Precisie en oog voor detail in elk project'
          }, {
            icon: <MessageSquare className="h-10 w-10" data-id="element-127" />,
            title: 'Transparantie',
            description: 'Duidelijke communicatie en eerlijk advies'
          }, {
            icon: <Users className="h-10 w-10" data-id="element-128" />,
            title: 'Persoonlijk',
            description: 'Korte lijnen en een betrokken team'
          }, {
            icon: <Truck className="h-10 w-10" data-id="element-129" />,
            title: 'Betrouwbaar',
            description: 'We komen onze afspraken altijd na'
          }].map((value, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-130">
                <div className="text-[#CDA735] mb-4" data-id="element-131">{value.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-132">
                  {value.title}
                </h3>
                <p className="text-gray-600" data-id="element-133">{value.description}</p>
              </div>)}
          </div>
        </div>
      </section>
      {/* Work process section */}
      <section className="py-20 bg-white" data-id="element-134">
        <div className="container mx-auto px-6" data-id="element-135">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-136">
            <div className="inline-flex items-center gap-3 mb-4 justify-center" data-id="element-137">
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-138"></div>
              <span className="text-sm font-medium text-[#B89429] uppercase tracking-wider" data-id="element-139">
                Onze werkwijze
              </span>
              <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-140"></div>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-141">
              Van idee tot realisatie
            </h2>
            <p className="text-lg text-gray-600" data-id="element-142">
              Bij Veranova maken we het proces van begin tot eind
              overzichtelijk, zorgeloos en professioneel. Ontdek hoe we te werk
              gaan.
            </p>
          </div>
          {/* Interactive steps */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12" data-id="element-143">
            {/* Steps sidebar */}
            <div className="lg:col-span-4 space-y-2" data-id="element-144">
              {workSteps.map(step => <div key={step.id} onClick={() => setActiveStep(step.id)} className={`p-4 rounded-lg cursor-pointer transition-all duration-300 flex items-center gap-4 ${activeStep === step.id ? 'bg-gray-100 shadow-sm' : 'hover:bg-gray-50'}`} data-id="element-145">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center ${activeStep === step.id ? step.color : 'bg-gray-100 text-gray-400'}`} data-id="element-146">
                    {step.icon}
                  </div>
                  <div data-id="element-147">
                    <h4 className={`font-semibold ${activeStep === step.id ? 'text-gray-900' : 'text-gray-600'}`} data-id="element-148">
                      {step.title}
                    </h4>
                    <p className={`text-sm ${activeStep === step.id ? 'text-gray-600' : 'text-gray-500'}`} data-id="element-149">
                      Stap {step.id}
                    </p>
                  </div>
                </div>)}
            </div>
            {/* Step detail */}
            <div className="lg:col-span-8 bg-gray-50 rounded-2xl overflow-hidden" data-id="element-150">
              {workSteps.map(step => <div key={step.id} className={`transition-all duration-500 h-full ${activeStep === step.id ? 'opacity-100' : 'opacity-0 hidden'}`} data-id="element-151">
                  <div className="grid grid-cols-1 md:grid-cols-2 h-full" data-id="element-152">
                    <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-153">
                      <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 ${step.color}`} data-id="element-154">
                        {step.icon}
                      </div>
                      <h3 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-155">
                        {step.title}
                      </h3>
                      <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-156">
                        {step.description}
                      </p>
                      {step.id < workSteps.length ? <button onClick={() => setActiveStep(step.id + 1)} className="inline-flex items-center text-[#CDA735] font-medium hover:text-[#B89429] transition-colors" data-id="element-157">
                          <span data-id="element-158">Volgende stap</span>
                          <ArrowRight className="ml-2 h-4 w-4" data-id="element-159" />
                        </button> : <button onClick={() => setActiveStep(1)} className="inline-flex items-center text-[#CDA735] font-medium hover:text-[#B89429] transition-colors" data-id="element-160">
                          <span data-id="element-161">Terug naar begin</span>
                          <ArrowRight className="ml-2 h-4 w-4" data-id="element-162" />
                        </button>}
                    </div>
                    <div className="bg-cover bg-center h-full min-h-[300px]" style={{
                  backgroundImage: `url(${step.id === 1 ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/31qoFLD89xVNfcg4Xki5Xk/491436229_17850212535441316_3063343797506131228_n.jpg' : step.id === 2 ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/1kkTSutEG3n1jaMh5paBAH/487922126_17848235598441316_7489604228845729630_n.jpg' : step.id === 3 ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/6hFDuMkKtrrN66CxmjRtGR/488225866_17848235589441316_3303414385176099418_n.jpg' : step.id === 4 ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/bbqzAX3HGa1qV4DnaGXJAq/IMG-20250423-WA0011.jpg' : step.id === 5 ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/6csxjgvfwC84VMs7DY8i12/IMG-20250423-WA0009.jpg' : 'https://uploadthingy.s3.us-west-1.amazonaws.com/7nk9VQSmML7hwtXboprLaz/IMG-20250423-WA0012.jpg'})`
                }} aria-label={`Illustratie voor stap ${step.id}: ${step.title}`} data-id="element-163"></div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>
      {/* FAQ section */}
      <section className="py-20 bg-gray-50" data-id="element-164">
        <div className="container mx-auto px-6" data-id="element-165">
          <div className="max-w-3xl mx-auto" data-id="element-166">
            <div className="text-center mb-12" data-id="element-167">
              <div className="inline-flex items-center gap-3 mb-4 justify-center" data-id="element-168">
                <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-169"></div>
                <span className="text-sm font-medium text-[#B89429] uppercase tracking-wider" data-id="element-170">
                  Veelgestelde vragen
                </span>
                <div className="w-8 h-[2px] bg-[#CDA735]" data-id="element-171"></div>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-172">
                Heeft u vragen?
              </h2>
              <p className="text-lg text-gray-600" data-id="element-173">
                Hieronder vindt u antwoorden op veelgestelde vragen. Staat uw
                vraag er niet tussen? Neem dan gerust contact met ons op.
              </p>
            </div>
            <div className="space-y-4" data-id="element-174">
              {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden" data-id="element-175">
                  <button className="w-full flex justify-between items-center p-6 text-left" onClick={() => toggleFaq(index)} aria-expanded={expandedFaq === index} aria-controls={`faq-answer-${index}`} data-id="element-176">
                    <h3 className="font-semibold text-lg text-gray-800" data-id="element-177">
                      {faq.question}
                    </h3>
                    {expandedFaq === index ? <ChevronUp className="h-5 w-5 text-[#CDA735]" data-id="element-178" /> : <ChevronDown className="h-5 w-5 text-gray-400" data-id="element-179" />}
                  </button>
                  <div id={`faq-answer-${index}`} className={`px-6 overflow-hidden transition-all duration-300 ${expandedFaq === index ? 'pb-6 max-h-40' : 'max-h-0'}`} data-id="element-180">
                    <p className="text-gray-600" data-id="element-181">{faq.answer}</p>
                  </div>
                </div>)}
            </div>
            <div className="mt-12 text-center" data-id="element-182">
              <a href="/offerte-aanvragen" className="inline-flex items-center bg-[#CDA735] hover:bg-[#B89429] text-white font-medium px-8 py-3.5 rounded-md shadow-lg transition-all transform hover:shadow-[0_0_20px_rgba(205,167,53,0.3)]" data-id="element-183">
                <span data-id="element-184">Vraag vrijblijvend een offerte aan</span>
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-185" />
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
};